import { tryParse as tryParse_3, fromParts, round } from "../fable-library.3.7.20/Decimal.js";
import { head, singleton, map, cons, foldBack, tail, empty, isEmpty } from "../fable-library.3.7.20/List.js";
import { some, value as value_1 } from "../fable-library.3.7.20/Option.js";
import { collect, unfold } from "../fable-library.3.7.20/Seq.js";
import { compare, sign, disposeSafe, getEnumerator } from "../fable-library.3.7.20/Util.js";
import { FSharpResult$2 } from "../fable-library.3.7.20/Choice.js";
import { FSharpRef } from "../fable-library.3.7.20/Types.js";
import { tryParse } from "../fable-library.3.7.20/Int32.js";
import { tryParse as tryParse_1, fromInt } from "../fable-library.3.7.20/Long.js";
import { tryParse as tryParse_2, minValue } from "../fable-library.3.7.20/Date.js";
import { replace } from "../fable-library.3.7.20/String.js";
import { tryParse as tryParse_4 } from "../fable-library.3.7.20/Double.js";
import { Queue$1__Enqueue_2B595, Queue$1__TryDequeue_404CD8EE, Queue$1__get_Count, Queue$1_$ctor } from "../fable-library.3.7.20/System.Collections.Generic.js";
import { class_type } from "../fable-library.3.7.20/Reflection.js";

export function Decimal_round(decimals, n) {
    return round(n, decimals);
}

export function List_safeTail(_arg) {
    if (isEmpty(_arg)) {
        return empty();
    }
    else {
        return tail(_arg);
    }
}

export function List_mapAll(f, l) {
    return foldBack((e, rs) => {
        if (rs == null) {
            return void 0;
        }
        else {
            const rs$0027 = rs;
            const matchValue = f(e);
            return (matchValue == null) ? (void 0) : cons(value_1(matchValue), rs$0027);
        }
    }, l, empty());
}

export function List_onList(ctor, xs, x) {
    return ctor(map((f) => f(x), xs));
}

export function List_groupAdjacent(key, keyEquality, selector, groupSelector, l) {
    const patternInput = foldBack((item, tupledArg) => {
        let gKey_1, gKey_2;
        const groupKey = tupledArg[0];
        const groupItems = tupledArg[1];
        const groups = tupledArg[2];
        const thisKey = key(item);
        return (groupKey != null) ? (keyEquality(value_1(groupKey), thisKey) ? ((gKey_1 = value_1(groupKey), [groupKey, cons(selector(item), groupItems), groups])) : ((gKey_2 = value_1(groupKey), [some(thisKey), singleton(selector(item)), cons([gKey_2, groupSelector(groupItems)], groups)]))) : [some(thisKey), singleton(selector(item)), empty()];
    }, l, [void 0, empty(), empty()]);
    const lastGroup = patternInput[1];
    const groups_1 = patternInput[2];
    const matchValue = [patternInput[0], lastGroup];
    let pattern_matching_result, gKey_3;
    if (matchValue[0] != null) {
        if (!isEmpty(matchValue[1])) {
            pattern_matching_result = 0;
            gKey_3 = value_1(matchValue[0]);
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return cons([gKey_3, groupSelector(lastGroup)], groups_1);
        }
        case 1: {
            return groups_1;
        }
    }
}

export function List_foldTo(f, seed, l) {
    const foldav$0027 = (f$0027_mut, a_mut, l_1_mut) => {
        foldav$0027:
        while (true) {
            const f$0027 = f$0027_mut, a = a_mut, l_1 = l_1_mut;
            if (!isEmpty(l_1)) {
                const matchValue = f$0027(a, head(l_1));
                if (matchValue[1] == null) {
                    f$0027_mut = f$0027;
                    a_mut = matchValue[0];
                    l_1_mut = tail(l_1);
                    continue foldav$0027;
                }
                else {
                    return [matchValue[0], some(value_1(matchValue[1]))];
                }
            }
            else {
                return [a, void 0];
            }
            break;
        }
    };
    const matchValue_1 = foldav$0027(f, seed, l);
    return [matchValue_1[0], matchValue_1[1]];
}

export function List_foldUntil(f, seed, l) {
    const folda$0027 = (f$0027_mut, a_mut, xs_mut) => {
        folda$0027:
        while (true) {
            const f$0027 = f$0027_mut, a = a_mut, xs = xs_mut;
            if (!isEmpty(xs)) {
                const matchValue = f$0027(a, head(xs));
                if (matchValue[1]) {
                    return matchValue[0];
                }
                else {
                    f$0027_mut = f$0027;
                    a_mut = matchValue[0];
                    xs_mut = tail(xs);
                    continue folda$0027;
                }
            }
            else {
                return a;
            }
            break;
        }
    };
    return folda$0027(f, seed, l);
}

export function Seq_iterate(f) {
    return (state_1) => unfold((state) => {
        const v = f(state);
        return [v, v];
    }, state_1);
}

export function Seq_foldTo(f, seed, s) {
    const foldav$0027 = (f$0027_mut, acc_mut, e_mut) => {
        foldav$0027:
        while (true) {
            const f$0027 = f$0027_mut, acc = acc_mut, e = e_mut;
            if (e["System.Collections.IEnumerator.MoveNext"]()) {
                const matchValue = f$0027(acc, e["System.Collections.Generic.IEnumerator`1.get_Current"]());
                if (matchValue[1] == null) {
                    f$0027_mut = f$0027;
                    acc_mut = matchValue[0];
                    e_mut = e;
                    continue foldav$0027;
                }
                else {
                    return [matchValue[0], some(value_1(matchValue[1]))];
                }
            }
            else {
                return [acc, void 0];
            }
            break;
        }
    };
    const e_1 = getEnumerator(s);
    try {
        const matchValue_1 = foldav$0027(f, seed, e_1);
        return [matchValue_1[0], matchValue_1[1]];
    }
    finally {
        disposeSafe(e_1);
    }
}

export function Seq_foldUntil(f, seed, s) {
    const folda$0027 = (f$0027_mut, acc_mut, e_mut) => {
        folda$0027:
        while (true) {
            const f$0027 = f$0027_mut, acc = acc_mut, e = e_mut;
            if (e["System.Collections.IEnumerator.MoveNext"]()) {
                const matchValue = f$0027(acc, e["System.Collections.Generic.IEnumerator`1.get_Current"]());
                if (matchValue[1]) {
                    return matchValue[0];
                }
                else {
                    f$0027_mut = f$0027;
                    acc_mut = matchValue[0];
                    e_mut = e;
                    continue folda$0027;
                }
            }
            else {
                return acc;
            }
            break;
        }
    };
    const e_1 = getEnumerator(s);
    try {
        return folda$0027(f, seed, e_1);
    }
    finally {
        disposeSafe(e_1);
    }
}

export function Option_foldTo(f, seed, xs) {
    if (xs == null) {
        return [seed, void 0];
    }
    else {
        const patternInput = f(seed, value_1(xs));
        return [patternInput[0], patternInput[1]];
    }
}

export function Option_foldUntil(f, seed, xs) {
    if (xs == null) {
        return seed;
    }
    else {
        return f(seed, value_1(xs))[0];
    }
}

export function Result_fold(f, seed, r) {
    if (r.tag === 1) {
        return seed;
    }
    else {
        return f(seed, r.fields[0]);
    }
}

export function Result_foldBack(f, r, seed) {
    if (r.tag === 1) {
        return seed;
    }
    else {
        return f(r.fields[0], seed);
    }
}

export function Result_foldTo(f, seed, xs) {
    if (xs.tag === 1) {
        return [seed, void 0];
    }
    else {
        const patternInput = f(seed, xs.fields[0]);
        return [patternInput[0], patternInput[1]];
    }
}

export function Result_foldUntil(f, seed, xs) {
    if (xs.tag === 1) {
        return seed;
    }
    else {
        return f(seed, xs.fields[0])[0];
    }
}

export function Result_Errorf(f) {
    return f.cont((arg) => (new FSharpResult$2(1, arg)));
}

export function Result_bindEm(f, fe, r) {
    if (r.tag === 1) {
        return fe(r.fields[0]);
    }
    else {
        return f(r.fields[0]);
    }
}

export function Array_foldTo(f, seed, a) {
    const foldav$0027 = (f$0027_mut, a_1_mut, arr_mut, i_mut) => {
        foldav$0027:
        while (true) {
            const f$0027 = f$0027_mut, a_1 = a_1_mut, arr = arr_mut, i = i_mut;
            if (i === arr.length) {
                return [a_1, void 0];
            }
            else {
                const matchValue = f$0027(a_1, arr[i]);
                if (matchValue[1] == null) {
                    f$0027_mut = f$0027;
                    a_1_mut = matchValue[0];
                    arr_mut = arr;
                    i_mut = (i + 1);
                    continue foldav$0027;
                }
                else {
                    return [matchValue[0], some(value_1(matchValue[1]))];
                }
            }
            break;
        }
    };
    const matchValue_1 = foldav$0027(f, seed, a, 0);
    return [matchValue_1[0], matchValue_1[1]];
}

export function Array_foldUntil(f, seed, a) {
    const folda$0027 = (f$0027_mut, a_1_mut, arr_mut, i_mut) => {
        folda$0027:
        while (true) {
            const f$0027 = f$0027_mut, a_1 = a_1_mut, arr = arr_mut, i = i_mut;
            if (i === arr.length) {
                return a_1;
            }
            else {
                const matchValue = f$0027(a_1, arr[i]);
                if (matchValue[1]) {
                    return matchValue[0];
                }
                else {
                    f$0027_mut = f$0027;
                    a_1_mut = matchValue[0];
                    arr_mut = arr;
                    i_mut = (i + 1);
                    continue folda$0027;
                }
            }
            break;
        }
    };
    return folda$0027(f, seed, a, 0);
}

export function Array_tryFindFromEnd(p, a) {
    const tryFindFromEnd$0027 = (i_mut) => {
        tryFindFromEnd$0027:
        while (true) {
            const i = i_mut;
            if (i < 0) {
                return void 0;
            }
            else if (p(a[i])) {
                return some(a[i]);
            }
            else {
                i_mut = (i - 1);
                continue tryFindFromEnd$0027;
            }
            break;
        }
    };
    return tryFindFromEnd$0027(a.length - 1);
}

export function Array_tryPickFromEnd(p, a) {
    const tryPickFromEnd$0027 = (i_mut) => {
        tryPickFromEnd$0027:
        while (true) {
            const i = i_mut;
            if (i < 0) {
                return void 0;
            }
            else {
                const matchValue = p(a[i]);
                if (matchValue == null) {
                    i_mut = (i - 1);
                    continue tryPickFromEnd$0027;
                }
                else {
                    return some(value_1(matchValue));
                }
            }
            break;
        }
    };
    return tryPickFromEnd$0027(a.length - 1);
}

export function Array_binSearch$0027(keySelector, selector, key, arr, r) {
    let indexStart = 0;
    let indexEnd = arr.length - 1;
    let result = false;
    let doContinue = true;
    while ((indexStart <= indexEnd) && doContinue) {
        const indexMid = (indexStart + ((indexEnd - indexStart) >> 1)) | 0;
        const midItem = arr[indexMid];
        const cr = sign(compare(key, keySelector(midItem))) | 0;
        switch (cr) {
            case -1: {
                indexEnd = ((indexMid - 1) | 0);
                break;
            }
            case 0: {
                r.contents = selector(midItem);
                doContinue = false;
                break;
            }
            default: {
                indexStart = ((indexMid + 1) | 0);
            }
        }
    }
    return result;
}

export function Array_binSearch(keySelector, key, arr) {
    let r = void 0;
    Array_binSearch$0027(keySelector, some, key, arr, new FSharpRef(() => r, (v) => {
        r = v;
    }));
    return r;
}

export function String_choose(f) {
    return (str) => (Array.from(collect((c) => {
        const matchValue = f(c);
        if (matchValue == null) {
            return "";
        }
        else {
            return matchValue;
        }
    }, str.split(""))).join(''));
}

export function String_chooseNot(f) {
    return (str) => (Array.from(collect((c) => {
        const matchValue = f(c);
        if (matchValue == null) {
            return c;
        }
        else {
            return "";
        }
    }, str.split(""))).join(''));
}

export function String_startsWith(start, str) {
    const startLen = start.length | 0;
    const startsWith$0027 = (i_mut) => {
        startsWith$0027:
        while (true) {
            const i = i_mut;
            if (i === startLen) {
                return true;
            }
            else if (start[i] === str[i]) {
                i_mut = (i + 1);
                continue startsWith$0027;
            }
            else {
                return false;
            }
            break;
        }
    };
    if (startLen > str.length) {
        return false;
    }
    else {
        return startsWith$0027(0);
    }
}

export const Parse_Byte = (str) => {
    let matchValue;
    let outArg = 0;
    matchValue = [tryParse(str, 511, true, 8, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
    return matchValue[0] ? matchValue[1] : (void 0);
};

export const Parse_SByte = (str) => {
    let matchValue;
    let outArg = 0;
    matchValue = [tryParse(str, 511, false, 8, new FSharpRef(() => outArg, (v) => {
        outArg = (v | 0);
    })), outArg];
    return matchValue[0] ? matchValue[1] : (void 0);
};

export const Parse_Int16 = (str) => {
    let matchValue;
    let outArg = 0;
    matchValue = [tryParse(str, 511, false, 16, new FSharpRef(() => outArg, (v) => {
        outArg = (v | 0);
    })), outArg];
    return matchValue[0] ? matchValue[1] : (void 0);
};

export const Parse_UInt16 = (str) => {
    let matchValue;
    let outArg = 0;
    matchValue = [tryParse(str, 511, true, 16, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
    return matchValue[0] ? matchValue[1] : (void 0);
};

export const Parse_Int32 = (str) => {
    let matchValue;
    let outArg = 0;
    matchValue = [tryParse(str, 511, false, 32, new FSharpRef(() => outArg, (v) => {
        outArg = (v | 0);
    })), outArg];
    return matchValue[0] ? matchValue[1] : (void 0);
};

export const Parse_UInt32 = (str) => {
    let matchValue;
    let outArg = 0;
    matchValue = [tryParse(str, 511, true, 32, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
    return matchValue[0] ? matchValue[1] : (void 0);
};

export const Parse_Int64 = (str) => {
    let matchValue;
    let outArg = fromInt(0);
    matchValue = [tryParse_1(str, 511, false, 64, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
    return matchValue[0] ? matchValue[1] : (void 0);
};

export const Parse_UInt64 = (str) => {
    let matchValue;
    let outArg = fromInt(0);
    matchValue = [tryParse_1(str, 511, true, 64, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
    return matchValue[0] ? matchValue[1] : (void 0);
};

export const Parse_DateTime = (str) => {
    let matchValue;
    let outArg = minValue();
    matchValue = [tryParse_2(str, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
    return matchValue[0] ? matchValue[1] : (void 0);
};

export const Parse_Date = (str) => {
    let matchValue;
    let outArg = minValue();
    matchValue = [tryParse_2(str, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
    return matchValue[0] ? matchValue[1] : (void 0);
};

export function Parse_Decimal(format, str) {
    const parseDotDecimal = (str$0027) => {
        let value = fromParts(0, 0, 0, false, 1);
        if (tryParse_3(str$0027, new FSharpRef(() => value, (v) => {
            value = v;
        }))) {
            return value;
        }
        else {
            return void 0;
        }
    };
    const _arg = ((format & 2) === 2) ? parseDotDecimal(str) : (void 0);
    if (_arg == null) {
        if ((format & 1) === 1) {
            return parseDotDecimal(replace(str, ",", "."));
        }
        else {
            return void 0;
        }
    }
    else {
        return _arg;
    }
}

export function Parse_Float(allowComma_mut, str_mut) {
    Parse_Float:
    while (true) {
        const allowComma = allowComma_mut, str = str_mut;
        let value = 0;
        if (tryParse_4(str, new FSharpRef(() => value, (v) => {
            value = v;
        }))) {
            return value;
        }
        else if (allowComma) {
            allowComma_mut = false;
            str_mut = replace(str, ",", ".");
            continue Parse_Float;
        }
        else {
            return void 0;
        }
        break;
    }
}

export function Parse_Single(allowComma_mut, str_mut) {
    Parse_Single:
    while (true) {
        const allowComma = allowComma_mut, str = str_mut;
        let value = Math.fround(0);
        if (tryParse_4(str, new FSharpRef(() => value, (v) => {
            value = v;
        }))) {
            return value;
        }
        else if (allowComma) {
            allowComma_mut = false;
            str_mut = replace(str, ",", ".");
            continue Parse_Single;
        }
        else {
            return void 0;
        }
        break;
    }
}

export class InstancePool$1 {
    constructor(ctor) {
        this.ctor = ctor;
        this.bag = Queue$1_$ctor();
    }
}

export function InstancePool$1$reflection(gen0) {
    return class_type("Svea.Dry.InstancePool`1", [gen0], InstancePool$1);
}

export function InstancePool$1_$ctor_9CB17FF(ctor) {
    return new InstancePool$1(ctor);
}

export function InstancePool$1__get_Size(x) {
    return Queue$1__get_Count(x.bag);
}

export function InstancePool$1__ClaimInstance(x) {
    let matchValue;
    let outArg = null;
    matchValue = [Queue$1__TryDequeue_404CD8EE(x.bag, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
    if (matchValue[0]) {
        return matchValue[1];
    }
    else {
        return x.ctor();
    }
}

export function InstancePool$1__ReleaseInstance_2B595(x, o) {
    Queue$1__Enqueue_2B595(x.bag, o);
}

export function InstancePool$1__WithInstance_Z1FC644CA(x, consumer) {
    const o = InstancePool$1__ClaimInstance(x);
    try {
        return consumer(o);
    }
    finally {
        InstancePool$1__ReleaseInstance_2B595(x, o);
    }
}

